import React from "react";
import { Upload } from "../../components/Upload";


const ShcUploadWrapper = ({ children, uploadFile }) => {

    return(
        <Upload.Dragger multiple={true} customRequest={uploadFile}>{children}</Upload.Dragger>
    );
};

export { ShcUploadWrapper };